import { styled } from '@linaria/react';

import { Captions } from '~components/Typography';

export const Badge = styled(Captions)`
	display: flex;
	min-width: 1.6rem;
	justify-content: center;
	padding-right: 0.3rem;
	padding-left: 0.3rem;
	border-radius: var(--radius-xl);
	background: var(--color-rose-58-solid);
	color: var(--color-white-solid);
`;

export const CounterBadge = ({
	count,
	className,
}: {
	count: number;
	className?: string;
}) => (
	<Badge className={className} size="L">
		{count}
	</Badge>
);
